import {URLSearchParams} from '@angular/http';

export abstract class AbstractService {

    protected searchQuery(name: string, value: any): URLSearchParams {
        const search: URLSearchParams = new URLSearchParams();
        search.append(name, value);
        return search;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/http/abstract.service.ts